var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoubleCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5126_1812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8393 6.45691L16.1373 14.6887C15.7835 15.8912 14.8944 16.7929 13.8003 17.2244C14.0893 16.5538 14.25 15.816 14.25 15.041V7.12508C14.25 4.06924 11.7634 1.58341 8.70833 1.58341H7.39021C8.36317 0.301702 10.0708 -0.322923 11.7008 0.175036L16.2022 1.55729C18.2637 2.19062 19.4465 4.38829 18.8393 6.45691ZM12.6667 7.12508V15.0417C12.6667 17.2244 10.891 19.0001 8.70833 19.0001H3.95833C1.77571 19.0001 0 17.2244 0 15.0417V7.12508C0 4.94245 1.77571 3.16674 3.95833 3.16674H8.70833C10.891 3.16674 12.6667 4.94245 12.6667 7.12508Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5126_1812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCard);
export default __webpack_public_path__ + "static/media/double-card.74df5ee868760c410a308b4417cd1376.svg";
export { ForwardRef as ReactComponent };